import React, {useEffect, useState} from "react";
import styled from "styled-components";
import IcPrevArrow from "../assets/icons/ic-pagination-arrow-left.svg";
import {toast} from "react-toastify";

const Pagination = ({totalItems, itemCountPerPage, pageCount, currentPage, setPageIndex}) => {
    const totalPages = Math.ceil(totalItems / itemCountPerPage);
    const [start, setStart] = useState(1);

    const noPrev = start === 1;
    const noNext = start + pageCount - 1 >= totalPages;

    // ✅ 수정 1: start 계산 로직 (누적 제거)
    useEffect(() => {
        const newStart =
            Math.floor((currentPage - 1) / pageCount) * pageCount + 1;

        if (newStart !== start) {
            setStart(newStart);
        }
    }, [currentPage, pageCount]);

    return (
        <PaginationContainer>
            <PaginationWrap>
                <button
                    className={"page-direction-btn prev-btn"}
                    onClick={() => {
                        if (currentPage === 1) {
                            toast('첫번째 페이지 입니다.');
                            return;
                        }
                        setPageIndex(currentPage - 1);
                    }}
                />

                <div className="page-number-btn-wrap">
                    {[...Array(pageCount)].map((_, idx) => (
                        <div key={idx}>
                            {start + idx <= totalPages && (
                                <button
                                    onClick={() => {
                                        setPageIndex(start + idx);
                                    }}
                                    className={`page-numbers ${
                                        currentPage === start + idx ? "active" : ""
                                    }`}
                                >
                                    {start + idx}
                                </button>
                            )}
                        </div>
                    ))}
                </div>

                <button
                    className="page-direction-btn next-btn"
                    onClick={() => {
                        if (currentPage === totalPages) {
                            toast('마지막 페이지 입니다.');
                            return;
                        }
                        setPageIndex(currentPage + 1);
                    }}
                />
            </PaginationWrap>
        </PaginationContainer>
    );
};

const PaginationContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const PaginationWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;

    button {
        width: 30px;
        height: 30px;
        border-radius: 2px;
    }

    .prev-btn {
        background-image: url(${IcPrevArrow});
        background-repeat: no-repeat;
        background-position: center;
    }

    .next-btn {
        transform: rotate(180deg);
        background-image: url(${IcPrevArrow});
        background-repeat: no-repeat;
        background-position: center;
    }

    button.page-direction-btn {
        transition: all 0.2s ease-in-out;
        background-color: var(--primary-100);
        opacity: 0.5;

        &:hover {
            opacity: 0.8;
        }
    }

    .page-number-btn-wrap {
        display: flex;
        align-items: center;
        justify-content: center;

        button.page-numbers {
            font-size: 13px;
            color: #757575;

            &.active {
                color: #fff;
                border-radius: 30px;
                background: #c86733;
                cursor: default;
            }

            &:not(.active):hover {
                color: #000;
            }
        }
    }
`;

export default Pagination;
